import { useState } from 'react';

import { useToastErrorHandler } from '@collab/libs/errors';
import { environment } from '@collab/utils/environment';

import { getApi, getVolvoIdTokenDemo } from 'libs/apim/apim.api';
import { AccessTokenWithTitle } from 'libs/volvoId/models';

const useDemoAccessToken = () => {
  const [token, setToken] = useState<AccessTokenWithTitle | null>(null);
  const [isGenerating, setGenerating] = useState(false);
  const [error, setError] = useState<any>(undefined);
  const handleWithToast = useToastErrorHandler();

  const generateToken = async (apiId: string) => {
    setGenerating(true);

    try {
      const [token, api] = await Promise.all([
        getVolvoIdTokenDemo(apiId),
        getApi(apiId),
      ]);

      if (token) {
        setToken({
          token,
          apiName: apiId,
          apiDisplayName: api.title,
        });
      } else {
        if (environment.IS_PROD) {
          throw new Error(`Could not generate demo token for API ${apiId}`);
        }

        setToken(getPlaceholderToken(apiId));
      }
    } catch (e) {
      setError(e);
      handleWithToast(e, errorMsg);
    } finally {
      setGenerating(false);
    }
  };

  const removeToken = () => {
    setToken(null);
  };

  return {
    isGenerating,
    token,
    error,
    generateToken,
    removeToken,
  };
};

export default useDemoAccessToken;

const errorMsg = {
  text: 'We could not generate your demo access token right now. Please try again later.',
  key: 'load-demo-access-token',
};

const getPlaceholderToken = (apiId: string): AccessTokenWithTitle => ({
  token: {
    accessToken: 'INVALID_DEMO_TOKEN',
    expiresOn: '000',
    expiresOnRaw: '000',
  },
  apiName: apiId,
  apiDisplayName: 'Non-valid API',
});
